import { render, staticRenderFns } from "./investmentManagement.vue?vue&type=template&id=398ecadc&scoped=true&"
import script from "./investmentManagement.vue?vue&type=script&lang=js&"
export * from "./investmentManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398ecadc",
  null
  
)

export default component.exports